import React from "react";

/**
 * Lightweight YouTube/Vimeo embed component.
 * Accepts any of:
 *   - https://www.youtube.com/watch?v=ID
 *   - https://youtu.be/ID
 *   - https://www.youtube.com/embed/ID
 *   - https://www.youtube.com/shorts/ID
 *   - https://vimeo.com/ID
 * Renders an iframe with strict sandboxing. Falls back to a clickable link
 * if the URL is not recognized.
 */
export default function VideoEmbed({ url }) {
  if (!url) return null;

  const yt = url.match(
    /(?:youtube\.com\/(?:watch\?v=|embed\/|shorts\/)|youtu\.be\/)([A-Za-z0-9_-]{6,})/i
  );
  const vimeo = url.match(/vimeo\.com\/(?:video\/)?(\d+)/i);

  let embedSrc = null;
  if (yt) {
    embedSrc = `https://www.youtube.com/embed/${yt[1]}?rel=0&modestbranding=1`;
  } else if (vimeo) {
    embedSrc = `https://player.vimeo.com/video/${vimeo[1]}?dnt=1`;
  }

  if (!embedSrc) {
    return (
      <a
        href={url}
        target="_blank"
        rel="noopener noreferrer"
        className="block text-xs text-gold-400 underline break-all mt-1"
      >
        {url}
      </a>
    );
  }

  return (
    <div className="relative w-full mt-2 border border-gold-700/30 bg-black" style={{ paddingTop: "56.25%" }}>
      <iframe
        title="Tigik News video"
        src={embedSrc}
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        allowFullScreen
        loading="lazy"
        className="absolute top-0 left-0 w-full h-full"
      />
    </div>
  );
}
